/* eslint-disable consistent-return */

import SimpleSchema from 'simpl-schema';

import AnnotationTemplates from '../AnnotationTemplates/AnnotationTemplates';

const AnnotationTemplatesSchema = AnnotationTemplates.schema.omit('owner', 'deleted');
AnnotationTemplatesSchema.extend({ _id: String });

export default new SimpleSchema({
  _id: {
    type: String,
    label: 'The ID of the annotation',
    optional: true
  },
  owner: {
    type: String,
    label: 'The ID of the user this annotation belongs to'
  },
  createdAt: {
    type: String,
    label: 'The date this annotation was created in the database',
    optional: true,
    autoValue() {
      if (this.isInsert) return new Date().toISOString();
    }
  },
  updatedAt: {
    type: String,
    label: 'The date this annotation was last updated',
    optional: true,
    autoValue() {
      if (this.isInsert || this.isUpdate) return new Date().toISOString();
    }
  },
  video: {
    type: String,
    label: 'The id of the video this annotations belongs to',
    optional: true
  },
  videoTime: {
    type: Number,
    label: 'The time in the video when this annotation was made in microseconds'
  },
  videoPosition: {
    type: Object,
    label:
      'This object represents the position of the annotation in the video in pixels. The (0,0) point is the top left corner of the video. The size of the video when the annotation was made will also be saved to guarantee the correct positioning if the video size is different later.'
  },
  'videoPosition.x': {
    type: Number,
    label: 'The number of pixels from the left side of the video'
  },
  'videoPosition.y': {
    type: Number,
    label: 'The number of pixels from the top side of the video'
  },
  'videoPosition.width': {
    type: Number,
    label: 'The width of the video when the annotation was made in pixels'
  },
  'videoPosition.height': {
    type: Number,
    label: 'The height of the video when the annotation was made in pixels'
  },
  template: {
    type: AnnotationTemplatesSchema,
    label: 'The structure of the annotation'
  },
  isProyected: {
    type: Boolean,
    label: 'The property of point proyected to line',
    optional: true
  },
  mapID: {
    type: String,
    label: 'The id of the video this annotations belongs to',
    optional: true
  },
  alias: {
    type: String,
    label: 'The structure of the annotation',
    optional: true
  }
});
